<template lang="pug">
.robo-folder(@click.stop="click(_key)") &nbsp;
  .title {{ title }}
  //-.themes
  //-  .heading Themes
  //-  .theme(v-for="{ t, th: { url } } in topThemes",
  //-         :title="t",
  //-         :style="{ 'background-image': `url('${ url }')` }")
  thumbs(:items="topThemes", heading="Themes")
  .docs
    .heading {{ totalDocsCount }} &nbsp;Documents
    .doc(v-for="{ t, id } in topDocs",
         :title="`${ trendingDocs[id] && 'Trending: ' || '' }${ t }`",
         :class="{ trending: trendingDocs[id] }"
         @click.stop="click(_key, id)",
         :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png')` }")
    .doc.no-zoom(v-if="totalDocsCount > 14", :title="`${ totalDocsCount - 14 } more documents`") &hellip;
  slot
</template>
<script>
import { mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import thumbs from './thumbs';
export default {
  name: 'folder',
  props: {
    item: Object,
    _key: String,
    button: Boolean
  },
  computed: {
    ...vuexComputed('folderDoco', 'insightsDoco', 'roboWeaveShown', 'notificationsShown', 'backToRobo', 'roboFolder', 'trending'),
    title() {
      return this.item?.title;
    },
    topDocId() {
      return this?.topDocs[0]?.id;
    },
    topDocs() {
      return this.item?.topDocs.slice(0, 14);
    },
    topThemes() {
      return this.item?.topThemes.slice(0, 18);
    },
    totalDocsCount() {
      return this.item?.totalDocsCount;
    },
    trendingDocs() {
      return this.trending
        ?.filter(item => item.type === 'document')
        .reduce((all, { id }) => {
          all[id] = true;
          return all;
        }, {}) || {};
    }
  },
  methods: {
    ...mapActions(['loadDoco', 'loadInsights', 'loadFolder']),
    async click(key, id) {
      const { topDocId } = this;
      id = id || topDocId;
      console.log('key/id', key, id);
      await this.loadInsights({ id });
      await(this.folderDoco = id);
      await(this.insightsDoco = id);
      await(this.roboFolder = key);
      await (this.backToRobo = true);
      //await (this.loadInsights(id));
      await (this.loadDoco(id));
      await (this.loadFolder(key));
      this.roboWeaveShown = this.notificationsShown = false;
      window.history.pushState({ fromRobo: true }, 'Weave - folder view');
      console.log('state added from robo folder view');
    }
  },
  components: { thumbs },
  mounted() {
    this.hub.$on('folder-click',e => {
      const { button, click, _key } = this;
      if (button) {
        if (e === _key) {
          click(_key);
          console.log('folder clicked: ', e, _key);
        }
      }
    });
  },
  destroyed() {
    this.hub.$off('folder-click');
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.robo-folder {
  box-sizing: border-box;
  display: flex;
  padding-top: 2.5rem;
  grid-template-columns: 10rem 1fr;
  //width: 6rem;
  margin: 0.25rem;
  height: 27rem;
  //display: none;
  //width: 3rem;
  //padding-top: 100%;
  background: white no-repeat center;
  background-size: contain;
  outline: 2px solid #dadada;
  position: relative;
  //box-shadow: 1px 1px 3px black;
  cursor: pointer;
  //outline: 1px solid black;
  transition: transform 250ms ease-in-out;
  will-change: transform;
  &:hover {
    z-index: 1;
  }
  & > .title {
    font-weight: 200;
    font-size: 1.5rem;
    white-space: nowrap;
    position: absolute;
    top: 0.25rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
  }

  //&.drop-target {
  //  transform: translate3d(1.5rem, 0, 0);
  //  &::before {
  //    content: '\00a0';
  //    position: absolute;
  //    top: 0;
  //    left: -1rem;
  //    height: 100%;
  //    width: 0.25rem;
  //    background-color: $brn;
  //  }
  //}
  &.selected {
    pointer-events: none;
    display: block;
    outline: 2px solid orange;
    /*box-shadow: 1px 1px 3px black,
                1px 1px 6px black,
                1px 1px 9px black;*/
  }

  //&.selected {
  //  pointer-events: all;
  //  box-shadow: 1px 1px 5px black;
  //}
  .heading {
    font-size: 1.5rem;
    font-weight: 200;
    position: absolute;
    top: 0.25rem;
    left: 0.5rem;
    opacity: 0.4;
    transition: opacity 250ms ease-in-out;
    will-change: opacity;
  }
  &.heading {
    grid-column-start: 1;
    grid-column-end: 6;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid #efefef;
    border-bottom-color: $brn;
    border-bottom-width: 2px;
    outline: none;
    padding-top: 0;
    margin: 1.5rem 0 0.25rem;
    font-weight: 500;
    color: $brn;
    font-size: 2rem;
    -webkit-font-smoothing: antialiased;
  }
  .themes {
    position: relative;
    display: grid;
    grid-template-columns: repeat(3, 3rem);
    grid-template-rows: repeat(4, 4.4rem);
    padding-top: 2rem;
    padding-left: 0.5rem;
    &:hover {
      .heading {
        opacity: 1;
      }
    }
    .theme {
      background: no-repeat center;
      background-size: contain;
      &:nth-child(2) {
        grid-column-end: span 2;
        grid-row-end: span 2;
      }
      &:nth-child(3) {
        grid-column-start: 2;
        grid-row-start: 3;
        grid-column-end: span 2;
        grid-row-end: span 2;
      }
    }
  }
  .docs {
    margin-left: 1rem;
    position: relative;
    display: grid;
    padding-top: 1.9rem;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 0.5rem;
    grid-row-gap: 0.25rem;
    &:hover {
      .heading {
        opacity: 1;
      }
    }
    .heading {
      left: auto;
      right: 0.25rem;
    }
    .doc {
      position: relative;
      //align-self: top;
      width: 5rem;
      height: 6.875rem;
      //width: 4rem;
      //height: 5.5rem;
      background: white no-repeat center;
      background-size: contain;
      border: 1px solid #ececec;
      will-change: transform;
      transition: transform 250ms ease-in-out 500ms;
      transform-origin: center center;
      &.trending {
        //outline: 1px solid orange;
        &::after {
          content: '';
          position: absolute;
          top: -0.125rem;
          left: -0.125rem;
          bottom: -0.125rem;
          right: -0.125rem;
          border: 0.25rem solid orange;
          border-radius: 0.25rem;
          animation: pulsate 4s ease-out infinite;
          z-index: -1;
        }
        @keyframes pulsate {
          0% { transform: scale(1); opacity: 0; }
          60% { transform: scale(1); opacity: 0; }
          //90% { opacity: 0.5; }
          //95% { transform: scale(1); }
          62% { opacity: 0.15; }
          100% { transform: scale(1.25); opacity: 0; }
        }
        //animation: pulsate 1s ease-out infinite;
        //keyframes pulsate {
        //  0% {-webkit-transform: scale(0.1, 0.1); opacity: 0;}
        //  50% {opacity: 1.0;}
        //  100% {-webkit-transform: scale(1.2, 1.2); opacity: 0;}
        //}
      }
      &.no-zoom {
        cursor: default;
      }
      &:not(.no-zoom):hover {
        z-index: 1;
        transform: scale(3);
      }
    }
  }
}
</style>
